const error404 = {
    title: 'Ошибка 404',
    header: 'Эту страницу не удалось найти 😳',
    message: "",
    link: "Вернуться в начало",
}

export default error404
